import {
  updateMarketIndicatorsType,
  updateMarketIndicatorsSuccessType,
  updateMarketIndicatorsFailureType,
} from 'actions/MarketIndicators/updateMarketIndicators';

const INITIAL_STATE = {
  isPending: false,
};

const updateMarketIndicatorsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case updateMarketIndicatorsType:
      return {
        isPending: true,
      };
    case updateMarketIndicatorsSuccessType:
    case updateMarketIndicatorsFailureType:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};

export { updateMarketIndicatorsReducer };
